import { assign } from 'xstate5';

import type { CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Resets the mixed dressing details.
 *
 * Can be used to remove any mixed dressings on dressing mode change.
 */
export const resetMixedDressingDetails: CustomizationMachineAction = assign(
  () => {
    return { mixedDressingDetails: [] };
  },
);
